var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('p',[_vm._v("BMS Flow "+_vm._s(_vm.getVersion()))]),_c('p',{staticClass:"hash"},[_vm._v(_vm._s(_vm.gitInfo.hash))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }